<template>
  <BaseIconDropdown :button-classes="buttonClasses" placement="top" icon="zmdi-help-outline">
    <slot name="full-control">
      <div class="help">
        <slot />
      </div>
    </slot>
  </BaseIconDropdown>
</template>

<script>
import BasePopper from '@/components/BasePopper.vue'
import BaseIconDropdown from '@/components/BaseIconDropdown.vue'

export default {
  name: 'BaseHelpPopper',
  components: {
    BaseIconDropdown,
    // eslint-disable-next-line vue/no-unused-components -- Baseline eslint ignore please fix if working on this
    BasePopper,
  },
  props: {
    buttonClasses: {
      type: [Object, Array, String],
      default: () => [],
    },
  },
}
</script>

<style scoped lang="scss">
.help {
  padding: 10px;
  min-width: 200px;
}
</style>
